import React, { useState, useEffect, useRef } from "react";
import ProfileModal from "../ProfileModal";
import { NavLink, useNavigate } from "react-router-dom";
import Draggable from "react-draggable";
import { AUTH_STORAGE_KEY, connectSocket, SERVER_URL } from "../../socket";
import { loadLabels, createLabel as apiCreateLabel, updateLabel as apiUpdateLabel, deleteLabel as apiDeleteLabel } from "../../api/labelsApi";
import { loadBookmarks as apiLoadBookmarks, createBookmark as apiCreateBookmark, updateBookmark as apiUpdateBookmark, deleteBookmark as apiDeleteBookmark } from "../../api/bookmarksApi";
import useContacts from "../../hooks/useContacts";
import StorageProgressBar from "./StorageProgressBar";
function MobileBottomNav({ onInboxClick, trashCount = 0, recentEmails = [], archiveCount = 0, onOpenSettings, onSignOut }) {
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  
  const [showQuickMenu, setShowQuickMenu] = useState(false);
  const [showChatModal, setShowChatModal] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);
  const [chatMessages, setChatMessages] = useState({});
  const [chatInput, setChatInput] = useState("");
  const [currentUser, setCurrentUser] = useState(null);
  const [labels, setLabels] = useState([]);
  const [bookmarks, setBookmarks] = useState([]);
  const [mobileBookmarkModalOpen, setMobileBookmarkModalOpen] = useState(false);
  const [mobileBookmarkName, setMobileBookmarkName] = useState("");
  const [mobileBookmarkLink, setMobileBookmarkLink] = useState("");
  const [mobileEditingBookmarkId, setMobileEditingBookmarkId] = useState(null);
  const [mobileLabelModalOpen, setMobileLabelModalOpen] = useState(false);
  const [mobileLabelName, setMobileLabelName] = useState("");
  const [mobileLabelColor, setMobileLabelColor] = useState("#536fb6");
  const [mobileLabelEmail, setMobileLabelEmail] = useState("");
  const [mobileEditingId, setMobileEditingId] = useState(null);
  const [mobileLabelsCollapsed, setMobileLabelsCollapsed] = useState(true);
  const [editingMsg, setEditingMsg] = useState(null);
  const [editText, setEditText] = useState("");

  const chatPanelRef = useRef(null);
  const chatMessagesEndRef = useRef(null);
  const socketRef = useRef(null);
  const historyLoadedRef = useRef(new Set());
  const { contacts } = useContacts();

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };
  const navigate = useNavigate();

  const closeMenu = () => {
    setShowMenu(false);
  };
const [role, setRole] = useState(3);

useEffect(() => {
  const raw = localStorage.getItem(AUTH_STORAGE_KEY);
  const parsed = raw ? JSON.parse(raw) : null;
  setRole(Number(parsed?.user?.role || 3));
}, []);
  // Initialize socket and current user for chat
  useEffect(() => {
    const load = async () => {
      try {
        const raw = localStorage.getItem(AUTH_STORAGE_KEY);
        const parsed = raw ? JSON.parse(raw) : null;
        const userId = parsed?.user?.email || parsed?.user?.username || parsed?.user?.userId || null;
        setCurrentUser(userId);

        if (!socketRef.current && parsed?.token) {
          socketRef.current = connectSocket(parsed.token);
        }
      } catch (err) {
        console.error("Failed to initialize chat socket", err);
      }
    };
    load();
  }, []);

  // Socket listeners for incoming messages
  useEffect(() => {
    const s = socketRef.current;
    if (!s || !currentUser) return;

    const onIncomingChat = (data) => {
      const { from, to, text, time, id } = data || {};
      if (!from || !to || !text) return;
      if (from === currentUser) return;

      const contactId = from;
      setChatMessages(prev => ({
        ...prev,
        [contactId]: [...(prev[contactId] || []), {
          id, from, to, text,
          timestamp: time,
          isOwn: false,
          pending: false
        }]
      }));
    };

    const onSentConfirmation = (data) => {
      const { clientId, id } = data || {};
      if (!clientId) return;

      setChatMessages(prev => {
        const updated = { ...prev };
        Object.keys(updated).forEach(contactId => {
          updated[contactId] = updated[contactId].map(msg =>
            msg.clientId === clientId ? { ...msg, id: id || msg.id, pending: false } : msg
          );
        });
        return updated;
      });
    };

    const onMessageDeleted = (data) => {
      const { id } = data || {};
      if (!id) return;
      setChatMessages(prev => {
        const updated = { ...prev };
        Object.keys(updated).forEach(contactId => {
          updated[contactId] = (updated[contactId] || []).filter(m => m.id !== id);
        });
        return updated;
      });
    };

    const onMessageUpdated = (data) => {
      const { id, text, edited } = data || {};
      if (!id || !text) return;
      setChatMessages(prev => {
        const updated = { ...prev };
        Object.keys(updated).forEach(contactId => {
          updated[contactId] = (updated[contactId] || []).map(m =>
            m.id === id ? { ...m, text, edited } : m
          );
        });
        return updated;
      });
    };

    s.on('chat_message', onIncomingChat);
    s.on('chat_message_sent', onSentConfirmation);
    s.on('message_updated', onMessageUpdated);
    // Note: message_deleted event no longer emitted by server (one-sided delete)

    return () => {
      s.off('chat_message', onIncomingChat);
      s.off('chat_message_sent', onSentConfirmation);
      s.off('message_updated', onMessageUpdated);
      // Note: message_deleted event listener removed (one-sided delete)
    };
  }, [currentUser]);

  // Delete message helper
  const handleDeleteMessage = async (msg) => {
    if (!msg) return;

    // If message is still optimistic (pending / clientId), remove locally
    if (msg.pending || msg.clientId && !msg.id) {
      setChatMessages(prev => {
        const updated = { ...prev };
        const list = (updated[selectedContact.id] || []).filter(m => (m.clientId || m.id) !== (msg.clientId || msg.id));
        updated[selectedContact.id] = list;
        return updated;
      });
      return;
    }

    try {
      const rawAuth = localStorage.getItem(AUTH_STORAGE_KEY);
      const parsedAuth = rawAuth ? JSON.parse(rawAuth) : null;
      const token = parsedAuth?.token;
      if (!token) throw new Error('Not authenticated');

      const res = await fetch(`${SERVER_URL}/messages/${encodeURIComponent(msg.id)}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!res.ok) throw new Error('Delete failed');

      setChatMessages(prev => {
        const updated = { ...prev };
        updated[selectedContact.id] = (updated[selectedContact.id] || []).filter(m => m.id !== msg.id);
        return updated;
      });
    } catch (err) {
      console.error('Failed to delete message', err);
    }
  };

  // Check if message can be edited (within 15 minutes)
  const canEditMessage = (msg) => {
    if (!msg || !msg.timestamp || !msg.isOwn) return false;
    const messageTime = typeof msg.timestamp === 'number' ? msg.timestamp : new Date(msg.timestamp).getTime();
    const now = Date.now();
    const fifteenMinutesMs = 15 * 60 * 1000;
    return (now - messageTime) < fifteenMinutesMs;
  };

  // Start editing message
  const handleEditMessage = (msg) => {
    if (!canEditMessage(msg)) return;
    setEditingMsg(msg);
    setEditText(msg.text || "");
  };

  // Submit edited message
  const handleSubmitEdit = async () => {
    if (!editingMsg || !editText.trim()) return;

    try {
      const raw = localStorage.getItem(AUTH_STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : null;
      const token = parsed?.token;
      if (!token) throw new Error('Not authenticated');

      const res = await fetch(`${SERVER_URL}/messages/${encodeURIComponent(editingMsg.id)}`, {
        method: 'PATCH',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ text: editText.trim() })
      });
      if (!res.ok) throw new Error('Edit failed');

      setChatMessages(prev => {
        const updated = { ...prev };
        const list = (updated[selectedContact.id] || []).map(m =>
          (m.id === editingMsg.id || m.clientId === editingMsg.clientId)
            ? { ...m, text: editText.trim(), edited: true }
            : m
        );
        updated[selectedContact.id] = list;
        return updated;
      });

      setEditingMsg(null);
      setEditText("");
    } catch (err) {
      console.error('Failed to edit message', err);
      alert('Failed to edit message');
    }
  };

  // Auto-scroll to bottom of chat
  useEffect(() => {
    if (chatMessagesEndRef.current) {
      chatMessagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [chatMessages, selectedContact]);

  // Fetch chat history when contact selected
  useEffect(() => {
    const fetchHistory = async () => {
      if (!selectedContact || !currentUser) return;
      
      const contactKey = selectedContact.id;
      if (historyLoadedRef.current.has(contactKey)) return;
      historyLoadedRef.current.add(contactKey);

      try {
        const raw = localStorage.getItem(AUTH_STORAGE_KEY);
        const parsed = raw ? JSON.parse(raw) : null;
        const token = parsed?.token;
        if (!token) return;

        const other = selectedContact.emails?.[0] || selectedContact.id;
        const res = await fetch(`${SERVER_URL}/api/messages/history?with=${encodeURIComponent(other)}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) return;

        const body = await res.json();
        const msgs = Array.isArray(body?.messages) 
          ? body.messages.map(m => ({ 
              id: m.id, 
              clientId: "",
              from: m.from, 
              to: m.to, 
              text: m.text, 
              timestamp: m.time, 
              isOwn: m.from === currentUser,
              pending: false
            })) 
          : [];

        setChatMessages(prev => ({ ...prev, [contactKey]: msgs }));
      } catch (err) {
        console.error("Failed to load chat history", err);
      }
    };

    fetchHistory();
  }, [selectedContact, currentUser]);

  const [secureMode, setSecureMode] = useState(false);

  const handleSendMessage = () => {
    if (!selectedContact || !chatInput.trim() || !currentUser) return;

    const other = selectedContact.emails?.[0] || selectedContact.id;
    const clientId = `${Date.now()}-${Math.random()}`;
    const payload = { clientId, from: currentUser, to: other, text: chatInput.trim(), timestamp: Date.now(), secure: Boolean(secureMode) };

    setChatMessages(prev => ({
      ...prev,
      [selectedContact.id]: [...(prev[selectedContact.id] || []), { 
        id: clientId,
        clientId,
        from: currentUser, 
        to: other, 
        text: payload.text, 
        timestamp: payload.timestamp, 
        isOwn: true,
        pending: true,
        secure: Boolean(secureMode)
      }]
    }));

    if (socketRef.current) {
      socketRef.current.emit('chat_message', payload);
    }

    setChatInput("");
  };

  useEffect(() => {
    if (!showChatModal) return;
    const handleClickOutside = (event) => {
      if (chatPanelRef.current && !chatPanelRef.current.contains(event.target)) {
        setShowChatModal(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showChatModal]);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const rawAuth = localStorage.getItem(AUTH_STORAGE_KEY);
        const parsedAuth = rawAuth ? JSON.parse(rawAuth) : null;
        const authHeaders = parsedAuth?.token ? { Authorization: `Bearer ${parsedAuth.token}` } : null;
        if (!authHeaders) {
          setLabels([]);
          return;
        }
        const res = await loadLabels(authHeaders);
        const list = Array.isArray(res?.labels) ? res.labels : [];
        if (!mounted) return;
        setLabels(list.map((l) => ({ ...(l || {}), color: l.color || '#536fb6' })));
        try {
          const bmRes = await apiLoadBookmarks(authHeaders);
          const list = Array.isArray(bmRes?.bookmarks) ? bmRes.bookmarks : [];
          if (!mounted) return;
          setBookmarks(list);
        } catch (e) {
          // fallback to localStorage if API fails or unauthenticated
          try {
            const raw = localStorage.getItem("MAIL_BOOKMARKS");
            const parsed = raw ? JSON.parse(raw) : [];
            if (Array.isArray(parsed)) setBookmarks(parsed);
          } catch {
            setBookmarks([]);
          }
        }
      } catch (err) {
        console.error('Failed to load labels', err);
        if (mounted) setLabels([]);
      }
    };
    load();
    const handler = () => load();
    window.addEventListener('labels-updated', handler);
    window.addEventListener('storage', handler);
    return () => { mounted = false; window.removeEventListener('labels-updated', handler); window.removeEventListener('storage', handler); };
  }, []);

  const openAddMobileLabel = () => {
    setMobileEditingId(null);
    setMobileLabelName("");
    setMobileLabelColor('#536fb6');
    setMobileLabelEmail("");
    setMobileLabelModalOpen(true);
  };

  const openAddMobileBookmark = () => {
    setMobileEditingBookmarkId(null);
    setMobileBookmarkName("");
    setMobileBookmarkLink("");
    setMobileBookmarkModalOpen(true);
  };

  const openEditMobileBookmark = (bm) => {
    setMobileEditingBookmarkId(bm.id);
    setMobileBookmarkName(bm.name || "");
    setMobileBookmarkLink(bm.link || "");
    setMobileBookmarkModalOpen(true);
  };

  const saveMobileBookmark = () => {
    (async () => {
      try {
        const rawAuth = localStorage.getItem(AUTH_STORAGE_KEY);
        const parsedAuth = rawAuth ? JSON.parse(rawAuth) : null;
        const authHeaders = parsedAuth?.token ? { Authorization: `Bearer ${parsedAuth.token}` } : null;
        const payload = { name: mobileBookmarkName.trim(), link: mobileBookmarkLink.trim() };
        if (authHeaders) {
          if (mobileEditingBookmarkId) {
            await apiUpdateBookmark(mobileEditingBookmarkId, payload, authHeaders);
          } else {
            await apiCreateBookmark(payload, authHeaders);
          }
          const bmRes = await apiLoadBookmarks(authHeaders);
          setBookmarks(Array.isArray(bmRes?.bookmarks) ? bmRes.bookmarks : []);
        } else {
          // fallback to localStorage when not authenticated
          try {
            const next = Array.isArray(bookmarks) ? [...bookmarks] : [];
            if (mobileEditingBookmarkId) {
              const idx = next.findIndex((b) => String(b.id) === String(mobileEditingBookmarkId));
              if (idx >= 0) next[idx] = { ...next[idx], name: mobileBookmarkName.trim(), link: mobileBookmarkLink.trim() };
            } else {
              next.push({ id: Date.now(), name: mobileBookmarkName.trim(), link: mobileBookmarkLink.trim() });
            }
            localStorage.setItem("MAIL_BOOKMARKS", JSON.stringify(next));
            setBookmarks(next);
          } catch (err) {
            console.error('Failed to save mobile bookmark', err);
          }
        }
      } catch (err) {
        console.error('Failed to save mobile bookmark', err);
      }
      setMobileBookmarkModalOpen(false);
    })();
  };

  const deleteMobileBookmark = (id) => {
    if (!window.confirm('Delete this bookmark?')) return;
    (async () => {
      try {
        const rawAuth = localStorage.getItem(AUTH_STORAGE_KEY);
        const parsedAuth = rawAuth ? JSON.parse(rawAuth) : null;
        const authHeaders = parsedAuth?.token ? { Authorization: `Bearer ${parsedAuth.token}` } : null;
        if (authHeaders) {
          await apiDeleteBookmark(id, authHeaders);
          const bmRes = await apiLoadBookmarks(authHeaders);
          setBookmarks(Array.isArray(bmRes?.bookmarks) ? bmRes.bookmarks : []);
        } else {
          const next = (bookmarks || []).filter((b) => String(b.id) !== String(id));
          localStorage.setItem("MAIL_BOOKMARKS", JSON.stringify(next));
          setBookmarks(next);
        }
      } catch (err) {
        console.error('Failed to delete mobile bookmark', err);
      }
    })();
  };

  const openEditMobileLabel = (lbl) => {
    setMobileEditingId(lbl.id);
    setMobileLabelName(lbl.name || '');
    setMobileLabelColor(lbl.color || '#536fb6');
    setMobileLabelEmail(lbl.emailMatch || '');
    setMobileLabelModalOpen(true);
  };

  const saveMobileLabel = async () => {
    try {
      const rawAuth = localStorage.getItem(AUTH_STORAGE_KEY);
      const parsedAuth = rawAuth ? JSON.parse(rawAuth) : null;
      const authHeaders = parsedAuth?.token ? { Authorization: `Bearer ${parsedAuth.token}` } : null;
      if (!authHeaders) throw new Error('Not authenticated');

      if (mobileEditingId) {
        await apiUpdateLabel(mobileEditingId, { name: mobileLabelName.trim(), color: mobileLabelColor, emailMatch: String(mobileLabelEmail || "").trim() }, authHeaders);
      } else {
        await apiCreateLabel({ name: mobileLabelName.trim(), color: mobileLabelColor, emailMatch: String(mobileLabelEmail || "").trim() }, authHeaders);
      }

      window.dispatchEvent(new CustomEvent('labels-updated'));
    } catch (err) {
      console.error('Failed to save mobile label', err);
    }
    setMobileLabelModalOpen(false);
  };

  const deleteMobileLabel = async (id) => {
    if (!window.confirm('Delete this label?')) return;
    try {
      const rawAuth = localStorage.getItem(AUTH_STORAGE_KEY);
      const parsedAuth = rawAuth ? JSON.parse(rawAuth) : null;
      const authHeaders = parsedAuth?.token ? { Authorization: `Bearer ${parsedAuth.token}` } : null;
      if (!authHeaders) throw new Error('Not authenticated');

      await apiDeleteLabel(id, authHeaders);
      window.dispatchEvent(new CustomEvent('labels-updated'));
    } catch (err) {
      console.error('Failed to delete mobile label', err);
    }
  };

  return (
    <>
       {showProfileModal && (
        <ProfileModal isOpen={showProfileModal} onClose={() => setShowProfileModal(false)} />
      )}

      <nav className="mobile-bottom-nav">
        <NavLink to="/Kmail" end className="mobile-nav-item" onClick={() => { closeMenu(); if (typeof onInboxClick === 'function') onInboxClick(); }}>
          <i className="fa-solid fa-envelope" />
          <span>Mail</span>
        </NavLink>
            <NavLink to="/kmail/krivachat" end className="mobile-nav-item" onClick={closeMenu}>
          <i className="fa-solid fa-comments" />
          <span>Chat</span>
        </NavLink>
        <NavLink to="/kmail/calls" end className="mobile-nav-item" onClick={closeMenu}>
          <i className="fa-solid fa-phone" />
          <span>Calls</span>
        </NavLink>
           <NavLink to="/" end className="mobile-nav-item" onClick={closeMenu}>
          <i className="fa-solid fa-location" />
          <span>Near By</span>
        </NavLink>
       
        <button
          type="button"
          className="mobile-nav-item menu-button"
          onClick={() => setShowQuickMenu(!showQuickMenu)}
          aria-label="Open quick menu"
        >
          <i className="fa-solid fa-ellipsis-vertical" />
        </button>
      </nav>

   
      {/* {showQuickMenu && (
        <div className="mobile-quick-menu-overlay" onClick={() => setShowQuickMenu(false)}>
          <div className="mobile-quick-menu-popup" onClick={(e) => e.stopPropagation()}>
            <NavLink to="/kmail/contacts" className="mobile-quick-menu-item" onClick={() => setShowQuickMenu(false)}>
              <i className="fa-solid fa-address-book" />
              <span>Contacts</span>
            </NavLink>
          
<button
              type="button"
              className="mobile-quick-menu-item"
              onClick={() => navigate(`/kmail/chat/server_0`)}
            >
              <i className="fa-solid fa-comments" />
              <span>Chat</span>
            </button>
            <a href="https://fms.bharatesoft.com/" className="mobile-quick-menu-item" onClick={() => setShowQuickMenu(false)}>
              <i className="fa-solid fa-desktop" />
              <span>FMS</span>
            </a>
            <button
              type="button"
              className="mobile-quick-menu-item"
              onClick={() => {
                setShowQuickMenu(false);
                // Open bookmark add modal directly
                openAddMobileBookmark();
              }}
            >
              <i className="fa-solid fa-bookmark" />
              <span>Bookmarks</span>
            </button>
            <button
              type="button"
              className="mobile-quick-menu-item"
              onClick={() => {
                setShowQuickMenu(false);
                // Open settings
                if (typeof onOpenSettings === 'function') {
                  onOpenSettings();
                } else {
                  navigate('/kmail/settings');
                }
              }}
            >
              <i className="fa-solid fa-user" />
              <span>Profile</span>
            </button>
          </div>
        </div>
      )} */}

{showQuickMenu && (
  <div className="mobile-quick-menu-overlay" onClick={() => setShowQuickMenu(false)}>
    <div className="mobile-quick-menu-sheet" onClick={(e) => e.stopPropagation()}>
        <button
    className="mobile-sheet-close"
    onClick={() => setShowQuickMenu(false)}
  >
    <i className="fa-solid fa-xmark"></i>
  </button>
      <div className="mobile-quick-menu-handle" />
      <div className="mobile-quick-menu-grid">

        {/* <NavLink to="/kmail/calls" className="mobile-grid-item" onClick={() => setShowQuickMenu(false)}>
          <div className="mobile-grid-icon"><i className="fa-solid fa-address-book" /></div>
          <span>Contacts</span>
        </NavLink> */}


        {/* <NavLink to="/kmail/krivachat" className="mobile-grid-item" onClick={() => setShowQuickMenu(false)}>
          <div className="mobile-grid-icon"><i className="fa-solid fa-comments" /></div>
          <span>Chat</span>
        </NavLink> */}

        

        {/* <NavLink to="/Kmail/sent" className="mobile-grid-item" onClick={() => setShowQuickMenu(false)}>
          <div className="mobile-grid-icon"><i className="fa-solid fa-paper-plane" /></div>
          <span>Sent</span>
        </NavLink>

        <NavLink to="/kmail/starred" className="mobile-grid-item" onClick={() => setShowQuickMenu(false)}>
          <div className="mobile-grid-icon"><i className="fa-solid fa-star" /></div>
          <span>Starred</span>
        </NavLink>

        <NavLink to="/kmail/drafts" className="mobile-grid-item" onClick={() => setShowQuickMenu(false)}>
          <div className="mobile-grid-icon"><i className="fa-solid fa-file-lines" /></div>
          <span>Drafts</span>
        </NavLink>

        <NavLink to="/kmail/archive" className="mobile-grid-item" onClick={() => setShowQuickMenu(false)}>
          <div className="mobile-grid-icon"><i className="fa-solid fa-box-archive" /></div>
          <span>Archive</span>
        </NavLink> */}

        {/* <NavLink to="/kmail/trash" className="mobile-grid-item" onClick={() => setShowQuickMenu(false)}>
          <div className="mobile-grid-icon"><i className="fa-solid fa-trash" /></div>
          <span>Trash</span>
        </NavLink> */}

        <NavLink to="/" className="mobile-grid-item" onClick={() => setShowQuickMenu(false)}>
          <div className="mobile-grid-icon"><i className="fa-solid fa-location-dot" /></div>
          <span>Nearby</span>
        </NavLink>

        {/* <NavLink to="/kmail/bookings" className="mobile-grid-item" onClick={() => setShowQuickMenu(false)}>
          <div className="mobile-grid-icon"><i className="fa-solid fa-calendar-check" /></div>
          <span>Bookings</span>
        </NavLink> */}

        <button type="button" className="mobile-grid-item" onClick={() => {
          setShowQuickMenu(false);
          if (typeof onOpenSettings === 'function') onOpenSettings();
          else navigate('/kmail/settings');
        }}>
          <div className="mobile-grid-icon"><i className="fa-solid fa-gear" /></div>
          <span>Settings</span>
        </button>

        <button type="button" className="mobile-grid-item" onClick={() => {
          setShowQuickMenu(false);
          const lockEnabled = localStorage.getItem("app-lock-enabled") === "true";
          if (lockEnabled && window.__lockApp) {
            window.__lockApp();
          } else {
            navigate('/kmail/settings?focus=app-lock');
          }
        }}>
          <div className="mobile-grid-icon"><i className="fa-solid fa-lock" /></div>
          <span>Lock</span>
        </button>

         <NavLink to="/add-service" className="mobile-grid-item" onClick={() => setShowQuickMenu(false)}>
          <div className="mobile-grid-icon"><i className="fa-solid fa-calendar-check" /></div>
          <span>Service</span>
        </NavLink>
{(role === 1 || role === 2) && (
  <>
    <NavLink
      to="/admin/service"
      className="mobile-grid-item"
      onClick={() => setShowQuickMenu(false)}
    >
      <div className="mobile-grid-icon">
        <i className="fa-solid fa-briefcase"></i>
      </div>
      <span>Admin Service</span>
    </NavLink>

 <NavLink to="/kmail/meeting" className="mobile-grid-item" onClick={() => setShowQuickMenu(false)}>
          <div className="mobile-grid-icon"><i className="fa-solid fa-video" /></div>
          <span>Meeting</span>
        </NavLink>
    <NavLink
      to="/admin/catalog-approval"
      className="mobile-grid-item"
      onClick={() => setShowQuickMenu(false)}
    >
      <div className="mobile-grid-icon">
        <i className="fa-solid fa-tags"></i>
      </div>
      <span>Category</span>
    </NavLink>

    <NavLink
      to="/admin/seo-categories"
      className="mobile-grid-item"
      onClick={() => setShowQuickMenu(false)}
    >
      <div className="mobile-grid-icon">
        <i className="fa-solid fa-layer-group"></i>
      </div>
      <span>SEO Category</span>
    </NavLink>

  <NavLink
      to="/admin/admin-approval"
      className="mobile-grid-item"
      onClick={() => setShowQuickMenu(false)}
    >
      <div className="mobile-grid-icon">
        <i className="fa-solid fa-briefcase"></i>
      </div>
      <span>Admin Approval</span>
    </NavLink>
    
    <NavLink
      to="/admin/fields"
      className="mobile-grid-item"
      onClick={() => setShowQuickMenu(false)}
    >
      <div className="mobile-grid-icon">
        <i className="fa-solid fa-list-check"></i>
      </div>
      <span>Fields</span>
    </NavLink>

    <NavLink
      to="/Kmail/slider"
      className="mobile-grid-item"
      onClick={() => setShowQuickMenu(false)}
    >
      <div className="mobile-grid-icon">
        <i className="fa-solid fa-images"></i>
      </div>
      <span>Slider</span>
    </NavLink>
  </>
)}

        {/* <NavLink to="/kmail/compose" className="mobile-grid-item" onClick={() => setShowQuickMenu(false)}>
          <div className="mobile-grid-icon"><i className="fa-solid fa-pen-to-square" /></div>
          <span>Compose</span>
        </NavLink> */}

        <button type="button" className="mobile-grid-item" onClick={() => {
          setShowQuickMenu(false);
          openAddMobileBookmark();
        }}>
          <div className="mobile-grid-icon"><i className="fa-solid fa-bookmark" /></div>
          <span>Bookmarks</span>
        </button>

        <button type="button" className="mobile-grid-item" onClick={() => { setShowQuickMenu(false); setShowProfileModal(true); }}>
          <div className="mobile-grid-icon"><i className="fa-solid fa-user" /></div>
          <span>Profile</span>
        </button>
   
      </div>
    </div>
  </div>
)}
      {mobileLabelModalOpen && (
        <div className="label-modal-overlay" role="dialog" aria-modal="true" onClick={() => setMobileLabelModalOpen(false)}>
          <div className="label-modal" onClick={(e) => e.stopPropagation()}>
            <h3>{mobileEditingId ? 'Edit Label' : 'New Label'}</h3>
            <div className="label-modal-row">
              <label>Name</label>
              <input value={mobileLabelName} onChange={(e) => setMobileLabelName(e.target.value)} />
            </div>
            <div className="label-modal-row">
              <label>Match Email (optional)</label>
              <select value={mobileLabelEmail} onChange={(e) => setMobileLabelEmail(e.target.value)}>
                <option value="">-- none --</option>
                {recentEmails && recentEmails.length > 0 ? (
                  recentEmails.map((em) => (
                    <option key={em} value={em}>{em}</option>
                  ))
                ) : null}
              </select>
            </div>
            <div className="label-modal-row">
              <label>Color</label>
              <input type="color" value={mobileLabelColor} onChange={(e) => setMobileLabelColor(e.target.value)} />
            </div>
            <div className="label-modal-actions">
              <button className="mail-top-btn secondary" onClick={() => setMobileLabelModalOpen(false)}>Cancel</button>
              <button className="mail-top-btn primary" onClick={saveMobileLabel} disabled={!mobileLabelName.trim()}>Save</button>
            </div>
          </div>
        </div>
      )}

      {mobileBookmarkModalOpen && (
        <div className="label-modal-overlay" role="dialog" aria-modal="true" onClick={() => setMobileBookmarkModalOpen(false)}>
          <div className="label-modal" onClick={(e) => e.stopPropagation()}>
            <h3>{mobileEditingBookmarkId ? 'Edit Bookmark' : 'New Bookmark'}</h3>
            
            {/* EXISTING BOOKMARKS LIST */}
            {bookmarks.length > 0 && (
              <div className="label-existing-list" style={{ maxHeight: 200, overflowY: 'auto', marginBottom: 16, borderBottom: '1px solid #e0e0e0', paddingBottom: 12 }}>
                {bookmarks.map((bm) => (
                  <div
                    key={bm.id}
                    className="mail-label-item"
                    style={{ display: 'flex', alignItems: 'center', padding: '8px', cursor: 'pointer', borderRadius: '4px', marginBottom: 6 }}
                    onClick={() => {
                      if (bm.link) window.open(bm.link, "_blank");
                    }}
                  >
                    <span className="mail-label-name" style={{ flex: 1, marginRight: 8 }}>{bm.name}</span>
                    <span className="label-actions" style={{ display: 'flex', gap: 4 }}>
                      <button
                        type="button"
                        className="label-action"
                        onClick={(e) => {
                          e.stopPropagation();
                          setMobileEditingBookmarkId(bm.id);
                          setMobileBookmarkName(bm.name || "");
                          setMobileBookmarkLink(bm.link || "");
                        }}
                        title="Edit"
                        style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#333', fontSize: 14 }}
                      >
                        <i className="fa-solid fa-pen-to-square" />
                      </button>
                      <button
                        type="button"
                        className="label-action"
                        onClick={(e) => {
                          e.stopPropagation();
                          deleteMobileBookmark(bm.id);
                        }}
                        title="Delete"
                        style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ef4444', fontSize: 14 }}
                      >
                        <i className="fa-solid fa-trash" />
                      </button>
                    </span>
                  </div>
                ))}
              </div>
            )}

            <div className="label-modal-row">
              <label>Name</label>
              <input value={mobileBookmarkName} onChange={(e) => setMobileBookmarkName(e.target.value)} />
            </div>
            <div className="label-modal-row">
              <label>Link (URL)</label>
              <input value={mobileBookmarkLink} onChange={(e) => setMobileBookmarkLink(e.target.value)} placeholder="https://example.com" />
            </div>
            <div className="label-modal-actions">
              <button className="mail-top-btn secondary" onClick={() => setMobileBookmarkModalOpen(false)}>Cancel</button>
              <button className="mail-top-btn primary" onClick={saveMobileBookmark} disabled={!mobileBookmarkName.trim() || !mobileBookmarkLink.trim()}>Save</button>
            </div>
          </div>
        </div>
      )}

      {showChatModal && (
        <Draggable handle=".right-chat-header" bounds="body">
          <div className="right-chat-panel" ref={chatPanelRef}>
            <div className="right-chat-header">
              <span>
                {selectedContact 
                  ? `Chat with ${selectedContact.name || selectedContact.emails?.[0]}` 
                  : "Quick Chat"}
              </span>
              <button onClick={() => { setShowChatModal(false); setSelectedContact(null); }}>×</button>
            </div>

            {!selectedContact ? (
              <div className="right-chat-contacts">
                <div className="right-chat-contacts-header">Select a contact to chat</div>
                <div className="right-chat-contacts-list">
                  {contacts.map((contact) => (
                    <button 
                      key={contact.id} 
                      className="right-chat-contact-item" 
                      onClick={() => setSelectedContact(contact)}
                    >
                      <div className="right-chat-contact-name">{contact.name || "Unknown"}</div>
                      <div className="right-chat-contact-email">{contact.emails?.[0] || ""}</div>
                    </button>
                  ))}
                  {contacts.length === 0 && (
                    <div className="right-chat-contacts-empty">No contacts available</div>
                  )}
                </div>
              </div>
            ) : (
              <>
                <div className="right-chat-messages">
                  {(chatMessages[selectedContact.id] || []).map((msg) => (
                    <div 
                      key={msg.id || msg.clientId}
                      className={`right-chat-message ${msg.isOwn ? 'own' : 'other'}`}
                    >
                      <div className="right-chat-message-content">{msg.secure && <span className="encrypted-badge" title="Encrypted message">🔒</span>}{msg.text}</div>
                      <div className="right-chat-message-actions">
                        <div className="right-chat-message-time">
                          {msg.timestamp ? new Date(msg.timestamp).toLocaleTimeString() : ''}
                          {msg.edited && <span className="msg-edited-label" title="Message was edited">(edited)</span>}
                        </div>
                        {msg.isOwn && (
                          <div className="msg-action-buttons">
                            {canEditMessage(msg) && (
                              <button className="msg-edit" title="Edit message (15 min limit)" onClick={() => handleEditMessage(msg)}>✎</button>
                            )}
                            <button className="msg-delete" title="Delete message" onClick={() => handleDeleteMessage(msg)}>🗑️</button>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                  <div ref={chatMessagesEndRef} />
                </div>

                <div className="right-chat-input">
                  <button 
                    className="right-chat-back-btn" 
                    onClick={() => setSelectedContact(null)}
                  >
                    ← Back
                  </button>
                  <input 
                    type="text" 
                    value={chatInput} 
                    onChange={(e) => setChatInput(e.target.value)} 
                    onKeyDown={(e) => { 
                      if (e.key === 'Enter' && chatInput.trim()) {
                        handleSendMessage();
                      }
                    }} 
                    placeholder="Type a message..." 
                  />
               
                  {secureMode && <span className="secure-pill" title="Message will be sent encrypted">Encrypted</span>}
                  <button onClick={() => handleSendMessage()}>Send</button>
                </div>
              </>
            )}
          </div>
        </Draggable>
      )}

      {/* Edit Message Modal */}
      {editingMsg && (
        <div className="edit-msg-overlay">
          <div className="edit-msg-modal">
            <h3>Edit Message</h3>
            <textarea 
              value={editText}
              onChange={(e) => setEditText(e.target.value)}
              placeholder="Edit your message..."
              className="edit-msg-textarea"
              onKeyDown={(e) => {
                if (e.key === 'Enter' && e.ctrlKey) {
                  handleSubmitEdit();
                }
              }}
            />
            <div className="edit-msg-hint">Ctrl+Enter to save or click Save</div>
            <div className="edit-msg-actions">
              <button 
                className="edit-msg-btn save"
                onClick={() => handleSubmitEdit()}
              >
                Save
              </button>
              <button 
                className="edit-msg-btn cancel"
                onClick={() => { setEditingMsg(null); setEditText(""); }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* <StorageProgressBar /> */}
    </>
  );
}

export default MobileBottomNav;
